import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Developer",
          "Upwork Freelancer",
          "MERN Stack Developer",
          "React Native Developer",
          "Open Source Contributor",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
        delay: 60,
      }}
    />
  );
}

export default Type;
